import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const Root = styled(Box)({
})

class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
        this.handleClose = this.handleClose.bind(this);
    }
    render() {
        const { open, msg, state } = this.props;
        return (
            <Root>
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={open} autoHideDuration={3000} onClose={this.handleClose}>
                    <Alert severity={state}>
                        {msg}
                    </Alert>
                </Snackbar>
            </Root>
        )
    }
    handleClose(e) {
        this.props.handleClose();
    }
}

export default Toast;